/**
 * Fieldset
 */
import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import { useFieldValidation } from '../hooks/useFieldValidation';
import { useFormValue } from '../context/Form.context';
import { ErrorSpan } from '../Labels';
var Fieldset = function (props) {
    var label = props.label, children = props.children, id = props.id, required = props.required, validationMessage = props.validationMessage, isInvalid = props.isInvalid, showError = props.showError, visibleFields = props.visibleFields, className = props.className;
    var _a = useFormValue(), invalidFields = _a[0].invalidFields, dispatch = _a[1];
    var _b = useState(false), valid = _b[0], setValid = _b[1];
    var _c = useState(false), touched = _c[0], setTouched = _c[1];
    var fieldRef = useRef(null);
    var _d = useFieldValidation(fieldRef, props), validateField = _d[0], showFieldError = _d[1], hideFieldError = _d[2];
    useEffect(function () {
        var validatedField = validateField('fieldset');
        if (validatedField.message) {
            setValid(false);
            dispatch({ type: 'FIELD_INVALID', field: validatedField });
        }
        else {
            setValid(true);
            if (invalidFields.includes(validatedField.id)) {
                dispatch({ type: 'FIELD_VALID', field: validatedField });
            }
        }
        var partOfVisibleFields = visibleFields &&
            visibleFields.filter(function (fieldName) { return fieldName.includes(id); });
        if (touched && !valid) {
            showFieldError(validatedField);
        }
        else if ((showError &&
            !valid &&
            visibleFields &&
            partOfVisibleFields &&
            partOfVisibleFields.length > 0) ||
            (showError && !valid && !visibleFields)) {
            setTouched(true);
            showFieldError(validatedField);
        }
        else {
            hideFieldError();
        }
    }, [
        valid,
        dispatch,
        touched,
        showError,
        setValid,
        validateField,
        showFieldError,
        hideFieldError,
        invalidFields,
        visibleFields,
        id,
    ]);
    return (React.createElement("fieldset", { className: clsx(className, 'border-greySemiLight', 'border', 'px-4', 'pt-4'), id: id, ref: fieldRef, onBlur: function () { return setTouched(true); } },
        React.createElement("legend", { className: "px-1 text-p" },
            label,
            required && React.createElement("abbr", { title: "Obligatoriskt" }, "*")),
        React.createElement("div", null, children),
        React.createElement(ErrorSpan, { fieldId: id, invalid: isInvalid, tabIndex: -1 }, validationMessage || '')));
};
export default Fieldset;
